module.exports = __webpack_public_path__ + "img/023.097a2ea4.png";